import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';
const TripEndTimeTooltip = ({
  placement,
  className,
  icon
}) => /*#__PURE__*/React.createElement(Tooltip, {
  placement: placement,
  className: className,
  content: I18n.t('pages.search.trip.unspecified_arrival_time')
}, icon);
TripEndTimeTooltip.propTypes = {
  placement: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.node
};
TripEndTimeTooltip.defaultProps = {
  placement: 'top',
  icon: /*#__PURE__*/React.createElement("span", {
    className: "span badge badge-warning badge-rounded badge--ticket pointer text-normal"
  }, " ? ")
};
export default TripEndTimeTooltip;